<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>{{ title }}</span></li>
            </ol>
            <div v-if="typeUser == 'admin'" class="right-wrapper pull-right">
                <!-- Las siguientes 3 importaciones (Imp. aparición de productos, Imp. Ingreso, Imp. Salida) tienen el mismo formato de ejemplo public/formats/import_product_inventory.xlsx -->
                <button type="button" class="btn btn-success btn-sm  mt-2 mr-2" @click.prevent="clickImportProducts()"><i class="fa fa-upload"></i> Imp. aparición de productos</button>
                <button type="button" class="btn btn-success btn-sm  mt-2 mr-2" @click.prevent="clickAddStockImport()"><i class="fa fa-upload"></i> Imp. Ingreso</button>
                <button type="button" class="btn btn-success btn-sm  mt-2 mr-2" @click.prevent="clickSubtractStockImport()"><i class="fa fa-upload"></i> Imp. Salida</button>
                <!--------------------------------------------------------------------------------------------------------------------->
                <button type="button" class="btn btn-success btn-sm  mt-2 mr-2" @click.prevent="clickImport()"><i class="fa fa-upload"></i> Imp. Ajuste de stock</button>
                <button type="button" class="btn btn-success btn-sm  mt-2 mr-2" @click.prevent="clickReportStock()"><i class="fa fa-file-excel"></i> Reporte Aj. stock</button>
                <button type="button" class="btn btn-success btn-sm  mt-2 mr-2" @click.prevent="clickReport()"><i class="fa fa-file-excel"></i> Reporte</button>

                
                <div class="btn-group flex-wrap">
                    <button
                        aria-expanded="false"
                        class="btn btn-custom btn-sm mt-2 mr-2 dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                    >
                        <i class="fa fa-upload"></i> Importar
                        <span class="caret"></span>
                    </button>
                    <div
                        class="dropdown-menu"
                        role="menu"
                        style="position: absolute;will-change: transform;top: 0px;left: 0px;transform: translate3d(0px, 42px, 0px);" x-placement="bottom-start">
                        <a class="dropdown-item text-1" href="#" @click.prevent="clickImportSpecialAttributes('item-lots-group')">Lotes</a>
                        <a class="dropdown-item text-1" href="#" @click.prevent="clickImportSpecialAttributes('item-lots')">Series</a>
                    </div>
                </div>

                <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2" @click.prevent="clickCreate('input')"><i class="fa fa-plus-circle"></i> Ingreso</button>
                <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2" @click.prevent="clickOutput()"><i class="fa fa-minus-circle"></i> Salida</button>
            </div>
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Listado de {{ title }}</h3>
            </div>
            <div class="card-body">
                <data-table :resource="resource" ref="datatable">
                    <tr slot="heading">
                        <th>
                            <el-dropdown>
                                <span class="el-dropdown-link">
                                    <el-button>
                                        <i class="fa fa-ellipsis-v"></i>
                                    </el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="onChecktAll">Seleccionar todo</el-dropdown-item>
                                    <el-dropdown-item @click.native="onUnCheckAll">Deseleccionar todo</el-dropdown-item>
                                    <el-dropdown-item @click.native="onOpenModalMoveGlobal">Trasladar</el-dropdown-item>
                                    <el-dropdown-item @click.native="onOpenModalStockGlobal">Ajustar stock</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </th>
                        <th>Producto</th>
                        <th>Almacén</th>
                        <th class="text-right">Stock</th>
                        <th class="text-right">Acciones</th>
                    </tr>
                                        <template slot-scope="{ index, row }">
                        <tr :key="'row-' + index">
                            <td>
                                <el-switch v-if="!row.has_variations" v-model="row.selected" @click="onChangeSelectedStatus(row)"></el-switch>
                            </td>
                            <td>
                                <!-- producto principal: nombre, "N variaciones" para desplegar y su código debajo -->
                                <template v-if="row.has_variations">
                                    <span class="font-weight-bold">{{ row.item_description }}</span>
                                    <el-tag size="mini"
                                            class="variations-toggle ml-1"
                                            @click="row.expanded = !row.expanded">
                                        {{ row.variations.length }} variaciones
                                        <i :class="row.expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                                    </el-tag>
                                    <!--<small v-if="row.item_internal_id"
                                           class="variation-codes d-block font-weight-bold">{{ row.item_internal_id }}</small>-->
                                </template>
                                <template v-else>{{ row.item_fulldescription }}</template>
                            </td>
                            <td>{{ row.warehouse_description }}</td>
                            <td class="text-right">{{ row.stock }}</td>
                            <td class="text-right">
                                <template v-if="!row.has_variations">
                                    <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                            @click.prevent="clickMove(row.id)">Trasladar</button>
                                    <button v-if="typeUser == 'admin'" type="button" class="btn waves-effect waves-light btn-xs btn-warning"
                                            @click.prevent="clickRemove(row.id)">Remover</button>
                                    <button type="button" class="btn waves-effect waves-light btn-xs btn-warning"
                                            @click.prevent="clickStock(row.id)">
                                        Ajuste
                                        <el-tooltip class="item"
                                                    content="Ajuste: stock del sistema no cuadre con el stock real"
                                                    effect="dark"
                                                    placement="top">
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                    </button>
                                </template>
                            </td>
                        </tr>
                        <template v-if="row.has_variations && row.expanded">
                            <tr v-for="variation in row.variations" :key="'variation-' + variation.id" class="bg-light">
                                <td>
                                    <el-switch v-model="variation.selected"></el-switch>
                                </td>
                                <td class="variation-name pl-4">
                                    <span class="text-muted">└</span>
                                    {{ row.item_description }}
                                    <template v-for="attribute in variation.variation_attributes">
                                        <span :key="'separator-' + attribute.id" class="variation-separator">·</span>
                                        <span :key="'attribute-' + attribute.id">
                                            <template v-if="attribute.color"><span :style="colorDotStyle(attribute.color)"></span>{{ attribute.value }}</template>
                                            <template v-else>{{ attribute.attribute }} {{ attribute.value }}</template>
                                        </span>
                                    </template>
                                    <small class="variation-codes">{{ variationCodes(variation) }}</small>
                                </td>
                                <td>{{ variation.warehouse_description }}</td>
                                <td class="text-right">{{ variation.stock }}</td>
                                <td class="text-right">
                                    <button type="button" class="btn waves-effect waves-light btn-xs btn-info"
                                            @click.prevent="clickMove(variation.id)">Trasladar</button>
                                    <button v-if="typeUser == 'admin'" type="button" class="btn waves-effect waves-light btn-xs btn-warning"
                                            @click.prevent="clickRemove(variation.id)">Remover</button>
                                    <button type="button" class="btn waves-effect waves-light btn-xs btn-warning"
                                            @click.prevent="clickStock(variation.id)">
                                        Ajuste
                                        <el-tooltip class="item"
                                                    content="Ajuste: stock del sistema no cuadre con el stock real"
                                                    effect="dark"
                                                    placement="top">
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </template>
                </data-table>
            </div>

            <inventories-form
                            :showDialog.sync="showDialog"
                            :type="typeTransaction"
                                ></inventories-form>

            <inventories-form-output
                            :showDialog.sync="showDialogOutput"
                            ></inventories-form-output>

            <inventories-move :showDialog.sync="showDialogMove"
                              :recordId="recordId"></inventories-move>
            <inventories-remove :showDialog.sync="showDialogRemove"
                                :recordId="recordId"></inventories-remove>
            <MoveGlobal :products="selectedItems" :show.sync="showHideModalMoveGlobal"></MoveGlobal>

            <movement-report
                            :showDialog.sync="showDialogMovementReport"
                                ></movement-report>

            <inventories-stock :showDialog.sync="showDialogStock"
                              :recordId="recordId"></inventories-stock>
                            
            <StockGlobal :products="selectedItems" :show.sync="showHideStockMoveGlobal"></StockGlobal>

            <stock-import :showDialog.sync="showImportDialog"></stock-import>

            <stock-report
                            :showDialog.sync="showDialogStockReport"
                                ></stock-report>


            <import-special-attributes 
                :showDialog.sync="showDialogSpecialAttributes"
                :special-attribute-type="special_attribute_type"
                ></import-special-attributes>

            <products-import :showDialog.sync="showImportProductsDialog"></products-import>

            <add-stock-import :showDialog.sync="showAddStockDialog"></add-stock-import>

            <subtract-stock-import :showDialog.sync="showSubtractStockDialog"></subtract-stock-import>

        </div>
    </div>
</template>

<script>

    import InventoriesForm from './form.vue'
    import InventoriesFormOutput from './form_output.vue'

    import InventoriesMove from './move.vue'
    import InventoriesRemove from './remove.vue'
    import DataTable from '@components/DataTable.vue'
    import MoveGlobal from './MoveGlobal.vue';
    import MovementReport from './reports/movement_report.vue';

    import InventoriesStock from './stock.vue'

    import StockGlobal from './StockGlobal.vue';

    import StockImport from './import.vue'
    
    import StockReport from './reports/stock_report.vue';
    import ImportSpecialAttributes from './partials/import_special_attributes.vue'
    
    import ProductsImport from './import_products.vue'
    import AddStockImport from './add_stock_import.vue'
    import SubtractStockImport from './subtract_stock_import.vue'
    import {colorDotStyle} from '@helpers/attribute_colors'

    export default {
        props: ['type', 'typeUser'],
        components: {DataTable, InventoriesForm, InventoriesMove, InventoriesRemove, InventoriesFormOutput, MoveGlobal, MovementReport, InventoriesStock, StockGlobal, StockImport, StockReport, ImportSpecialAttributes, ProductsImport, AddStockImport, SubtractStockImport},
        data() {
            return {
                showHideModalMoveGlobal: false,
                selectedItems: [],
                title: null,
                showDialog: false,
                showDialogMove: false,
                showDialogRemove: false,
                showDialogOutput: false,
                resource: 'inventory',
                recordId: null,
                typeTransaction:null,
                showDialogMovementReport:false,
                showDialogStock: false,
                showHideStockMoveGlobal: false,
                showImportDialog: false,
                showDialogStockReport:false,
                showDialogSpecialAttributes:false,
                special_attribute_type: null,
                showImportProductsDialog: false,
                showAddStockDialog: false,
                showSubtractStockDialog: false,
            }
        },
        created() {
            this.title = 'Inventario'
        },
        methods: {
        colorDotStyle,
            variationCodes(variation) {
                // código interno y código de barras de la variación: "00038-ROJ-L · 000000000039"
                //return [variation.item_internal_id, variation.item_barcode].filter(code => code).join(' · ')
                return 'Cód. Interno: ' + variation.item_internal_id + ' · Cód. de Barras: ' + variation.item_barcode
            },
            clickImportSpecialAttributes(type)
            {
                this.showDialogSpecialAttributes = true
                this.special_attribute_type = type
            },
            clickReport(){
                this.showDialogMovementReport = true
            },
                        getSelectableRecords() {
                // filas normales y variaciones; el producto principal no maneja stock
                return this.$refs.datatable.records.reduce((all, row) => {
                    return row.has_variations ? all.concat(row.variations) : all.concat([row])
                }, [])
            },
            async onOpenModalMoveGlobal() {
              const itemsSelecteds = this.getSelectableRecords().filter(p => p.selected);
                if (itemsSelecteds.length > 0) {
                    this.selectedItems = itemsSelecteds;
                    this.showHideModalMoveGlobal = true;
                } else {
                    this.$message({
                        message: 'Selecciona uno o más productos.',
                        type: 'warning'
                    });
                }
            },
            async onChangeSelectedStatus(row) {
                this.$refs.datatable.records = await this.$refs.datatable.records.map(r => {
                    if (r.id === row.id) {
                        r.selected = row.selected ? false : true;
                    }
                    return r;
                });
                this.$forceUpdate();
            },
                        onChecktAll() {
                this.getSelectableRecords().forEach(r => this.$set(r, 'selected', true))
            },
            onUnCheckAll() {
                this.getSelectableRecords().forEach(r => this.$set(r, 'selected', false))
            },

            clickMove(recordId) {
                this.recordId = recordId
                this.showDialogMove = true
            },
            clickCreate(type) {
                this.recordId = null
                this.typeTransaction = type
                this.showDialog = true
            },
            clickRemove(recordId) {
                this.recordId = recordId
                this.showDialogRemove = true
            },
            clickOutput() {
                this.recordId = null
                this.showDialogOutput = true
            },
            clickStock(recordId) {
                this.recordId = recordId
                this.showDialogStock = true
            },
            async onOpenModalStockGlobal() {
                const itemsSelecteds = this.getSelectableRecords().filter(p => p.selected);
                if (itemsSelecteds.length > 0) {
                    this.selectedItems = itemsSelecteds;
                    this.showHideStockMoveGlobal = true;
                } else {
                    this.$message({
                        message: 'Selecciona uno o más productos.',
                        type: 'warning'
                    });
                }
            },
            clickImport(){
                this.showImportDialog = true
            },
            clickReportStock(){
                this.showDialogStockReport = true
            },

            clickImportProducts(){
                this.showImportProductsDialog = true
            },
            clickAddStockImport(){
                this.showAddStockDialog = true
            },
            clickSubtractStockImport(){
                this.showSubtractStockDialog = true
            },

        }
    }
</script>
<style scoped>
/* "N variaciones" funciona como botón para desplegar las variaciones */
.variations-toggle {
    cursor: pointer;
}

/* separador "·" entre el nombre del principal y cada atributo */
.variation-separator {
    margin: 0 4px;
    color: #c0c4cc;
}

/* segunda línea: código interno y código de barras */
.variation-codes {
    color: #909399;
}

/* en la variación, los códigos van en su propia línea, alineados después de "└" */
.variation-name .variation-codes {
    display: block;
    padding-left: 14px;
}
</style>



// WEBPACK FOOTER //
// modules/Inventory/Resources/assets/js/inventory/index.vue